/*
 * The six hues `Exercise.jpg`'s tray cycles through, in the tray's own order.
 * Not the seven-family ramp: only three of these are family hues at all, and
 * none of the three land in this order, so the tray is its own palette rather
 * than a slice of the deck's. Split out of `VoteToken.tsx` so the drag ghost
 * in `usePainVoteDrag` can read the same sequence without importing a
 * component module.
 */
const STICKER_COLORS = [
  "var(--family-5-cover)", // olive
  "var(--family-2-bloom)", // lavender
  "var(--status-draft)", // coral
  "var(--vote-pink)", // pink
  "var(--family-6-bloom)", // blue
  "var(--family-7-bloom)", // red
]

export function stickerColor(index: number): string {
  const i = ((index % STICKER_COLORS.length) + STICKER_COLORS.length) % STICKER_COLORS.length
  return STICKER_COLORS[i]
}
